/* eslint-disable import/no-cycle */
import { MediaType } from '@src/model/frontendmodel';
import { getUserId } from '@src/selectors/user';
//TODO fix cycle dependency
import store from '@src/store/reduxstore';
import type { ChatContact, ChatTray } from '@src/types/chats';
import BackendProxy from './backendproxy';
import { countUnrepliedMessagesInChat } from './summarizestate';

// eslint-disable-next-line import/prefer-default-export
export const getOnceChatById = async (chatId: string): Promise<ChatTray> => {
  const state = store.getState();
  const userId = getUserId(state);

  // eslint-disable-next-line no-useless-catch
  try {
    const chat = await BackendProxy.loadChatById(userId, chatId);

    if (chat.events?.length) {
      chat.messagesSinceLastResponse = countUnrepliedMessagesInChat(chat);

      const lastEvent = chat.events.at(-1);
      chat.lastMessage = lastEvent.payload;
      chat.lastMessage.mediaType = chat.lastMessage.mediaType || MediaType.TEXT;
    }

    if (chat.contactAccount) {
      chat.contact = {
        id: chat?.contactAccount?.accountOwner?.id,
        fullName: chat?.contactAccount?.accountOwner?.fullName,
        avatarUrl: chat?.contactAccount?.avatarUrl,
        cmaId: chat?.contactAccount?.cmaId,
      } as ChatContact;
    }
    chat.show = false;

    return chat;
  } catch (err) {
    throw err;
  }
};
